import { Modal } from '@mui/material';
import { Grid } from '@mui/system';
import { BackupCodesContainerProps } from './types';

const BackupCodesContainer = ({ children, handleClose, isModal = false, openModal }: BackupCodesContainerProps) => {
  if (isModal) {
    return (
      <Modal
        open={!!openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        {children}
      </Modal>
    );
  }

  return <Grid container>{children}</Grid>;
};

export default BackupCodesContainer;
